'use client';

import { Heart } from "@/components/private/heart";
import { modalShow } from "@/components/private/actions/modal";

export default function VideoFavoriteLocked({ className, }: { className: string }) {
  return (
    <span
      className={className}
      onClick={() => modalShow(`locked`)}
    >
      <Heart />
      <span>favorite</span>
    </span>
  );
}
